@if (displayElement.applepayButton) {
<h-apple-pay-button class="flex-button size-{{ size }}" [disabled]="isDisabled" [size]="size"> </h-apple-pay-button>
} @if ( !needToOpenModal() && displayElement.termsAndConditions && (applePayFacade.status$ | async) ===
status.TermValidating ) {
<ng-container [ngTemplateOutlet]="termsAndConditions"> </ng-container>
}
<ng-template #termsAndConditions>
    <h-apple-pay-terms-and-conditions [ngClass]="{ 'margin-top': product }"> </h-apple-pay-terms-and-conditions>
</ng-template>
